import { gsap } from 'gsap'
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-creative';
import { Pagination, Navigation, EffectCreative } from 'swiper/modules';

export default {
  init() {
    console.log('home');
    gsap.registerPlugin(ScrollToPlugin);

    const scrollerHero = document.querySelector('#scrollerHero');

    const homeProductSlider = new Swiper(".prodottiCreativeSlider", {
      loop: true,
      modules: [Pagination, Navigation, EffectCreative],
      grabCursor: true,
      
      centeredSlides: true, 
      //initialSlide: 1, // Sposta la slide attiva sulla seconda
      initialSlide: 0, // Sposta la slide attiva sulla prima
      effect: 'creative',
      creativeEffect: {
        perspective: true,
        limitProgress: 5,
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
          creativeEffect:{
            prev: {
              translate: ['-80%', 0, 0],
              rotate: [0, 0, -20],
              origin: 'bottom',
              // scale: 0.9,
            },
            next: {
              translate: ['70%', 0, 0],
              rotate: [0, 0, 20],
              origin: 'bottom',
              // scale: 0.9,
            },
          }
        },
        200: {
          slidesPerView: 2,
          creativeEffect: {
            prev: {
              translate: ['-110%', 0, 0],
              rotate: [0, 0, -20],
              origin: 'bottom',
              scale: 0.9,
            },
            next: {
              translate: ['110%', 0, 0],
              rotate: [0, 0, 20],
              origin: 'bottom',
              scale: 0.9,
            },
          }
        },

      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      
      speed: 800,
    });
  

    const videoOverlay = document.querySelector('.videoOverlay');
    const btnOpenVideo = document.querySelector('#hpVideoOverlay');
    const btnCloseVideo = document.querySelector('.closeVideoOverlay');

    if (btnOpenVideo && videoOverlay) {
        const videoElement = videoOverlay.querySelector('video');

        btnOpenVideo.addEventListener('click', () => {
            console.log("apri video con audio");
            videoOverlay.classList.add('openVideoOverlay');
            
            // forza audio e avvia
            videoElement.muted = false; 
            videoElement.volume = 1; // max vol
            videoElement.play().catch(error => {
                console.error("Errore durante la riproduzione:", error);
            });
        });

        btnCloseVideo.addEventListener('click', () => {
            videoOverlay.classList.remove('openVideoOverlay');
            videoElement.pause();
            videoElement.currentTime = 0;
            videoElement.muted = true; // ritorna muto
        });
    }

    new Swiper('.swiperHomeNewsRelated', {
			modules: [Navigation],
			slideToClickedSlide: false,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			slidesPerView: 1,
			breakpoints: {
        1200: {
          slidesPerView: 3,
        },
				1024: {
					slidesPerView: 2.5,
				},
        640: {
          slidesPerView: 2.2,
        },
				320: {
					slidesPerView: 1.1,
          spaceBetween: 20,
				},
			},
			spaceBetween: 30,
			direction: 'horizontal',
			loop: false,
    });

    scrollerHero.addEventListener('click', () => {
      gsap.to(window, {
        duration: .5,
        scrollTo: {
          y: '#mortadellaHp',
          offsetY: 100,
          autoKill: false,
          ease: 'power3.Out'
        }
      });
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
